import { useState } from 'react';
import { Button } from 'shared-components';
import { UploadZone } from '../uploader/upload-zone';
import { close } from '../modal/modalSlice';
import { ButtonTier } from 'shared-components';
import { useAppDispatch } from '../../app/hooks';
import { Upload } from '../uploader/uploader.types';
import { useSetWatermarkMutation } from './settings.api';
import styles from './watermark-upload-modal.module.css';

export const WatermarkUploadModal = () => {
  const dispatch = useAppDispatch();
  const [uploadList, setUploadList] = useState<
    Pick<Upload, 'file' | 'destination'>[]
  >([]);
  const [setWatermark] = useSetWatermarkMutation();
  return (
    <div className={styles.watermarkUploadModal}>
      <UploadZone
        className={styles.uploadZone}
        allowMultiple={false}
        onlyOneMessage="Please select only one file"
        onFileChange={(files) => {
          const newList = files.map((file) => ({
            file,
            destination: ``,
          }));
          setUploadList(newList);
        }}
      />
      <Button
        bigger={true}
        tier={ButtonTier.Secondary}
        onClick={() => {
          dispatch(close());
        }}
      >
        Cancel
      </Button>
      {uploadList.length > 0 && (
        <Button
          bigger={true}
          onClick={async () => {
            await setWatermark({
              image: uploadList[0].file,
            });

            dispatch(close());
          }}
        >
          Upload
        </Button>
      )}
    </div>
  );
};
